module.exports = __webpack_public_path__ + "/images/embarazada-p-800.f3fbeff.jpeg";